import {
  IonContent,
  IonHeader,
  IonPage,
  IonRouterOutlet,
  IonToolbar,
} from "@ionic/react";
import { Route, useParams } from "react-router";
import ExploreContainer from "../../components/formComponents/ExploreContainer/ExploreContainer";
import "./Page.css";
import { Typography } from "@mui/joy";
import HeaderMenu from "../../components/formComponents/Menu/Menu";

import { FC } from "react";

type PageProps = {
  MenuComponent?: FC<any>;
};

const Page: FC<PageProps> = () => {
  const { name } = useParams<{ name: string }>();

  return (
    <>
      <HeaderMenu />
      <IonPage>
        <IonHeader>
          <IonToolbar>
            <Typography level="title-md">{name.toUpperCase()}</Typography>
          </IonToolbar>
        </IonHeader>
        <IonContent fullscreen>
          <IonHeader collapse="condense">
            <IonToolbar>
              <Typography level="title-md">{name.toUpperCase()}</Typography>
            </IonToolbar>
          </IonHeader>
          <ExploreContainer name={name} />
        </IonContent>
      </IonPage>
    </>
  );
};

export default Page;

